<div class="main-wrapper">
  <div class="flex flex-col">
    <app-navbar></app-navbar>
    @if (isUserLoggedIn) {
      <div class="loading-indicator-container">
        <app-loading-indicator></app-loading-indicator>
      </div>
    }
  </div>
  <div class="page-wrapper">
    @if (isUserLoggedIn && isTermsAccepted) {
      <app-sidebar userRoles [role]="allowedRoles"></app-sidebar>
    }
    <div
      class="content-wrapper relative"
      [class]="{
        'gap-0': !isUserLoggedIn,
      }"
      [style.padding]="!isUserLoggedIn ? '0' : ''"
    >
      <div class="sticky top-0 z-50 w-full">
        <app-notifications></app-notifications>
      </div>

      <div [class]="{ 'page-padding': isUserLoggedIn, 'h-full': !isUserLoggedIn }">
        <router-outlet> </router-outlet>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
